<template>
  <el-card shadow="never">
    <div slot="header" class="card-header">
      <span>分享奖励记录</span>
    </div>

    <div class="toolbar">
      <el-input v-model.trim="query.sharerUserId" placeholder="分享人用户ID" clearable />
      <el-input v-model.trim="query.visitorUserId" placeholder="访问人用户ID" clearable />
      <el-select v-model="query.sceneType" placeholder="分享场景" clearable>
        <el-option label="商品分享" value="product" />
        <el-option label="团购分享" value="group_buy" />
      </el-select>
	  <div>
		  <el-button @click="resetQuery">重置</el-button>
		  <el-button type="primary" @click="handleSearch">查询</el-button>
	  </div>
    </div>

    <el-table v-loading="loading" :data="list" border>
      <el-table-column prop="id" label="记录ID" width="90" />
      <el-table-column label="分享关系" min-width="220">
        <template slot-scope="{ row }">
          <div>分享人：{{ row.sharerNickname || '-' }} (#{{ row.sharerUserId || '-' }})</div>
          <div class="sub-text">访问人：{{ row.visitorNickname || '-' }} (#{{ row.visitorUserId || '-' }})</div>
        </template>
      </el-table-column>
      <el-table-column label="场景/目标" min-width="220">
        <template slot-scope="{ row }">
          <div>{{ row.sceneType === 'group_buy' ? '团购分享' : '商品分享' }}</div>
          <div class="sub-text">{{ row.targetName || `商品 #${row.targetId || '-'}` }}</div>
          <div v-if="row.groupBuyRecordId" class="sub-text">拼团 #{{ row.groupBuyRecordId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="访问奖励" min-width="220">
        <template slot-scope="{ row }">
          <el-tag :type="statusType(row.visitRewardStatus)" size="mini">{{ statusText(row.visitRewardStatus) }}</el-tag>
          <div class="sub-text">积分：{{ row.visitRewardPoints || 0 }}</div>
          <div class="sub-text">{{ row.visitRewardRemark || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="支付奖励" min-width="220">
        <template slot-scope="{ row }">
          <el-tag :type="statusType(row.payRewardStatus)" size="mini">{{ statusText(row.payRewardStatus) }}</el-tag>
          <div class="sub-text">积分：{{ row.payRewardPoints || 0 }}</div>
          <div class="sub-text">订单：{{ row.payRewardOrderNo || '-' }}</div>
          <div class="sub-text">{{ row.payRewardRemark || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="时间" min-width="200">
        <template slot-scope="{ row }">
          <div>访问：{{ row.visitTime || '-' }}</div>
          <div class="sub-text">过期：{{ row.expireTime || '-' }}</div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page.sync="query.pageNum"
        :page-size="query.pageSize"
        :total="total"
        @current-change="loadData"
      />
    </div>
  </el-card>
</template>

<script>
import { getShareRewardRecords } from '../../api/admin'

export default {
  data() {
    return {
      loading: false,
      total: 0,
      list: [],
      query: {
        sharerUserId: '',
        visitorUserId: '',
        sceneType: '',
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    handleSearch() {
      this.query.pageNum = 1
      this.loadData()
    },
    resetQuery() {
      this.query = {
        sharerUserId: '',
        visitorUserId: '',
        sceneType: '',
        pageNum: 1,
        pageSize: 10
      }
      this.loadData()
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          pageNum: this.query.pageNum,
          pageSize: this.query.pageSize,
          ...(this.query.sharerUserId ? { sharerUserId: Number(this.query.sharerUserId) } : {}),
          ...(this.query.visitorUserId ? { visitorUserId: Number(this.query.visitorUserId) } : {}),
          ...(this.query.sceneType ? { sceneType: this.query.sceneType } : {})
        }
        const data = await getShareRewardRecords(params)
        this.list = data.list || []
        this.total = data.total || 0
      } catch (error) {
        this.$message.error(error?.message || '分享奖励记录加载失败')
      } finally {
        this.loading = false
      }
    },
    statusText(status) {
      const map = { 0: '待处理', 1: '已发放', 2: '已跳过' }
      return map[status] || '待处理'
    },
    statusType(status) {
      const map = { 0: 'info', 1: 'success', 2: 'warning' }
      return map[status] || 'info'
    }
  }
}
</script>

<style scoped>
.card-header { font-weight: 600; }
.toolbar { display: grid; grid-template-columns: 180px 180px 160px auto auto; gap: 12px; margin-bottom: 16px; }
.sub-text { margin-top: 6px; color: #909399; font-size: 12px; line-height: 1.6; }
.pager { display: flex; justify-content: flex-end; margin-top: 16px; }
</style>
